import { UsersTable } from '../..//components/tables/Tables';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../components/spinner/Spinner';
import NothingToSeeHere from '../../components/nothing-to-see-here/NothingToSeeHere';
import { config } from '../../Constants';

const Users = () => {
  const [data, setData] = useState([]);
  const baseURL = config.baseURL;

  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLoading(false);
        setData(data.users);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content users-page'>
      <div className='title-btn'>
        <h1 className='title'>Customers</h1>
        <button className='primary'>
          <FaPlus /> Add
        </button>
      </div>
      {loading ? (
        <PageSpinner />
      ) : !loading && data.length > 0 ? (
        <UsersTable data={data} />
      ) : (
        <NothingToSeeHere />
      )}
    </main>
  );
};

export default Users;
